import React, { useState } from 'react';
import UserFormGroup from '@magoosh/pages/payment_flows/subscription_form/user_form_group';
import { Formik, FormikHelpers } from 'formik';
import * as yup from 'yup';
import { paths } from 'config/path_helpers';
import { PrimaryButton } from '@magoosh/lib/button';
import EuPrivacyPolicy from '@magoosh/pages/payment_flows/subscription_form/eu_privacy_policy';
import fetch from 'utilities/fetch';
import UsPrivacyPolicy from '@magoosh/pages/payment_flows/subscription_form/us_privacy_policy';

// A user form view for 2-step signup. This form is submitted so that the credentials can be
// validated without creating an account, for the purpose of sending cart-abandon emails. After
// this form is successfully submitted, the purchase view is shown.

interface Props {
  authenticityToken: string;
  isEuUser: boolean;
  setUserFormData: any;
}

interface UserFormValues {
  authenticityToken: string;
  email: string;
  password: string;
  termsAndPolicyAccepted: boolean;
}

const StandaloneUserRegistrationForm: React.FC<Props> = (props) => {
  const [buttonSubmitting, setButtonSubmitting] = useState(false);

  const validationSchema = yup.object({
    authenticityToken: yup.string().required(),
    email: yup.string().label('Email').required(),
    password: yup.string().label('Password').required(),
    passwordConfirmation: yup.string().label('Password confirmation').required()
  });

  const initialValues = {
    authenticityToken: props.authenticityToken,
    email: '',
    password: '',
    passwordConfirmation: '',
    termsAndPolicyAccepted: !props.isEuUser
  };

  const handleOnSubmit = async (
    values: UserFormValues,
    { setSubmitting, setErrors }: FormikHelpers<UserFormValues>
  ): Promise<void> => {
    setButtonSubmitting(true);
    setSubmitting(true);

    fetch(paths.api.validateUser(), {
      method: 'POST',
      body: JSON.stringify(values)
    })
      .then((response) => {
        props.setUserFormData(values);
      })
      .catch((response) => {
        setErrors(response.errors.user);
        setSubmitting(false);
        setButtonSubmitting(false);
      });
  };

  return (
    <div>
      <h3>Create an Account</h3>

      <Formik initialValues={initialValues} onSubmit={handleOnSubmit} validationSchema={validationSchema}>
        {({ values, isSubmitting, handleSubmit, setFieldValue, errors }) => {
          return (
            <>
              <UserFormGroup />
              {props.isEuUser && <EuPrivacyPolicy />}
              <PrimaryButton
                className={'u-margin-B-m'}
                onClick={handleSubmit}
                disabled={!values.termsAndPolicyAccepted}
                submitting={buttonSubmitting}>
                Continue
              </PrimaryButton>
              {!props.isEuUser && <UsPrivacyPolicy />}
            </>
          );
        }}
      </Formik>
    </div>
  );
};

export default StandaloneUserRegistrationForm;
